import template from "./forbidden.html";
import en from "./en.json";
import es from "./es.json";
import _ from "lodash";
import { homescreenState } from "../../../../base.routes";

class ForbiddenController {
    /* @ngInject */
    constructor() {
        this.homescreenState = homescreenState;
    }

    $onInit() {
        let ctrl = this;
        if (_.isEmpty(ctrl.redirect.params) && !ctrl.redirect.state) {
            ctrl.redirect.state = homescreenState.name;
            ctrl.redirect.params = {};
        }
    }
}

export default {
    name: "forbidden",
    template: template,
    bindings: { redirect: "<" },
    translations: { en, es },
    controller: ForbiddenController,
};
